
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';

import FindDiagonictics from './Components/Pages/FindDiagonictics';
import Request from './Components/Pages/Request';

import Patient from './Components/Pages/Patient';
import ViewDiagonstics from './Components/Pages/ViewDiagonstics';
import Login from './Components/Pages/Login';
import Dashboard from './Components/Pages/Dashboard';
import ViewHospitals from './Components/Pages/ViewHospitals';
import FindHospitals from './Components/Pages/FindHospitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { Toaster } from 'sonner';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
       <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: {
            background: "#000",     
            color: "#fff",       
            borderRadius: "10px",   
            padding: "14px 18px",
            fontSize: "14px",
          },
        }}
      />
      <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/dashboard' element={<Dashboard/>}/>
        <Route path='/find-hospitals' element={<FindHospitals/>}/>
        <Route path='/find-diagonistics' element={<FindDiagonictics/>}/>
        <Route path='/request' element={<Request/>}/>
        <Route path='/patients' element={<Patient/>}/>
         <Route path='/view-hospitals' element={<ViewHospitals/>}/>
          <Route path='/view-diagonistics' element={<ViewDiagonstics/>}/>
      </Routes>
      </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
